import { Component, EventEmitter, Input, OnChanges, OnInit, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl } from '@angular/forms';

@Component({
  selector: 'app-form-select-v2',
  templateUrl: './form-select-v2.component.html',
  styleUrls: ['./form-select-v2.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormSelectComponentV2),
      multi: true
    }
  ]
})
export class FormSelectComponentV2 implements OnInit, OnChanges, ControlValueAccessor {

  @Input() labelText: string;
  @Input() options : Array<String | Object> = [];
  @Input() labelKey: string;
  @Input() valueKey: string;
  @Input() placeholder: string;
  @Input() disableList?: boolean = false;
  @Input() control: FormControl;
  @Input() returnObject: boolean = false;
  @Input() disableKey: string;

  /**
   * Extra cssClass for the popup this select opens. The create-shift page
   * passes 'staffy-select' to get the redesigned chrome; every other screen
   * passes nothing and keeps the existing look.
   */
  @Input() interfaceCssClass: string = '';

  /**
   * Heading for the popup when the field has no visible label to borrow — the
   * per-day timing rows label their columns in a table header instead.
   */
  @Input() popupHeader: string = '';

  /**
   * Open the popup scrolled to the selected option. Long lists (the rate
   * dropdown) otherwise open at the top and make the user scroll to the
   * preselected value.
   */
  @Input() scrollToSelected: boolean = false;

  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();


  _value: any;
  propagateChange = (_: any) => {};
  propagateTouched = (_: any) => {};

  constructor(

  ) { }

  /** Options handed to the ion-select popup. Rebuilt only when an input
   *  actually changes — ion-select reads this on open, and handing it a fresh
   *  object every change-detection pass would churn the input for no reason. */
  interfaceOptions: { cssClass: string; header?: string } = { cssClass: 'references-select' };

  ngOnInit() {
    this.buildInterfaceOptions();
  }

  /**
   * Some labels are bound and change at runtime — the rate field reads
   * "Hourly Rate" or "Per Visit Rate" depending on the pay model — so the
   * popup heading has to follow the label rather than keep whatever it said
   * when the component was created.
   */
  ngOnChanges() {
    this.buildInterfaceOptions();
  }

  private buildInterfaceOptions() {
    // Field labels carry the required marker ('* Hourly Rate'); the popup
    // heading should not. Without a header the popup opened with a blank bar
    // above the options and no indication of what was being chosen.
    // Selects inside the Broadcast option cards carry no label — the card
    // title is their label — so fall back to the placeholder rather than
    // opening a popup with a blank heading.
    const header = (this.popupHeader || '').trim()
      || (this.labelText || '').replace(/^\s*\*\s*/, '').trim()
      || (this.placeholder || '').trim()
      || undefined;
    const cssClass = ('references-select ' + this.interfaceCssClass).trim();

    if (this.interfaceOptions.header === header && this.interfaceOptions.cssClass === cssClass) {
      return;
    }
    this.interfaceOptions = { cssClass, header };
  }


  get value(): any {
    return this._value;
  }

  set value(value:  any) {
    this._value = value;
    this.propagateChange(this._value);
    this.onChange.emit(value);
  }


  // fetchObject(): Object {
  //   return this.options.find( (obj) => {return obj[this.dataKey] === this.value})
  // }

  scrollSelectedIntoView() {
    if (!this.scrollToSelected || this.disableList) { return; }
    // The popup is created outside this component after the click, so wait for it to render
    setTimeout(() => {
      const selected = document.querySelector('ion-alert.references-select .alert-radio-button[aria-checked="true"]');
      if (selected) {
        // Centered, so the user has options above and below the selected one
        selected.scrollIntoView({ block: 'center' });
      }
    }, 300);
  }

  handlePopup() {
    // this.showPopup.emit();
  }

  //Form Accessor Functions for custom components
  writeValue(value: any): void {
    this._value = value;
  }
  
  touched($event){
    this.propagateTouched($event);
  }

  registerOnChange(fn: (value: any) => void): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.propagateTouched = fn;
  }

}
